// Contact page translations
const contactTranslations = {
  en: {
    hero: {
      kicker: "contact / start something",
      title: "want to work together?",
      intro: "have an idea? big, small, strange, unfinished — we're listening. let's make something together."
    },
    contactStrip: ["01 — idea", "02 — conversation", "03 — make"],
    card: {
      sendMessage: "send us a message",
      email: "prayrit@thewhizkind.com",
      findUs: "find us here",
      socials: {
        instagram: "instagram",
        linkedin: "linkedin"
      }
    },
    form: {
      title: "contact form",
      kicker: "say hello",
      sections: {
        whoAreYou: {
          index: "01",
          question: "who are you?",
          name: {
            label: "your name",
            placeholder: "e.g. Alex Müller"
          },
          email: {
            label: "your email",
            placeholder: "e.g. alex@example.com"
          }
        },
        whatAreWeMaking: {
          index: "02",
          question: "what are we making?",
          hint: "optional",
          projectTypes: [
            "web",
            "ai",
            "automation",
            "digitalisation",
            "branding",
            "graphic design",
            "something else"
          ],
          otherPlaceholder: "go on, tell us"
        },
        tellUsAboutIt: {
          index: "03",
          question: "tell us about it.",
          hint: "optional",
          placeholder: "an idea, a problem, a half-finished thought…"
        },
        addSomething: {
          index: "04",
          question: "add something.",
          hint: "optional",
          uploadText: "brief / image / sketch / pdf / whatever helps",
          fileTooBig: "that file's too big — please keep attachments under 10MB."
        }
      },
      submit: {
        button: "send it",
        sending: "sending",
        sent: "sent",
        success: "got it — we'll get back to you soon.",
        error: "something went wrong sending your message — please try emailing us directly."
      },
      honeypot: "website"
    }
  },
  de: {
    hero: {
      kicker: "kontakt / etwas beginnen",
      title: "willst du mit uns zusammenarbeiten?",
      intro: "hast du eine idee? groß, klein, ungewöhnlich, unfertig — wir hören zu. lass uns gemeinsam etwas erschaffen."
    },
    contactStrip: ["01 — idee", "02 — gespräch", "03 — umsetzen"],
    card: {
      sendMessage: "schreib uns",
      email: "prayrit@thewhizkind.com",
      findUs: "hier findest du uns",
      socials: {
        instagram: "Instagram",
        linkedin: "LinkedIn"
      }
    },
    form: {
      title: "kontaktformular",
      kicker: "hallo sagen",
      sections: {
        whoAreYou: {
          index: "01",
          question: "wer bist du?",
          name: {
            label: "dein name",
            placeholder: "z.B. Alex Müller"
          },
          email: {
            label: "deine e-mail",
            placeholder: "z.B. alex@beispiel.de"
          }
        },
        whatAreWeMaking: {
          index: "02",
          question: "was können wir tun?",
          hint: "optional",
          projectTypes: [
            "webentwicklung",
            "ki",
            "automatisierung",
            "digitalisierung",
            "markenentwicklung",
            "grafikdesign",
            "etwas anderes"
          ],
          otherPlaceholder: "erzähl uns mehr"
        },
        tellUsAboutIt: {
          index: "03",
          question: "erzähl uns davon.",
          hint: "optional",
          placeholder: "eine idee, ein problem, ein halbfertiger gedanke…"
        },
        addSomething: {
          index: "04",
          question: "füge etwas hinzu.",
          hint: "optional",
          uploadText: "brief / bild / skizze / pdf / was auch immer hilft",
          fileTooBig: "diese datei ist zu groß — bitte halte die größe von anhängen unter 10MB."
        }
      },
      submit: {
        button: "absenden",
        sending: "wird gesendet",
        sent: "gesendet",
        success: "erhalten — wir melden uns bald bei dir.",
        error: "beim senden deiner nachricht ist ein fehler aufgetreten — bitte versuch, uns direkt per e-mail zu kontaktieren."
      },
      honeypot: "website"
    }
  }
};

export default contactTranslations;